import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { ExclusionsPage } from '@/components/MarketingRules/ExclusionsPage'
import {
  exclusionsSearchSchema,
  withoutExclusionsSearchDefaults,
} from '@/components/MarketingRules/search'

/** Wiring only. The schema lives beside the page in `search.ts`. */
export const Route = createFileRoute('/_app/marketing/rules-v2/exclusions/')({
  validateSearch: exclusionsSearchSchema,
  component: ExclusionsRoute,
})

function ExclusionsRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <ExclusionsPage
      search={search}
      onSearchChange={(next) =>
        void navigate({
          search: (current) => withoutExclusionsSearchDefaults({ ...current, ...next }),
          replace: true,
        })
      }
    />
  )
}
